import {
    invalidateList,
    updateListFilter,
    clearListFilter,
    updateListOrdering,
    isListLoading,
    isListHandlingPost,
    getFilter,
    updateListSelection,
    getSelectedIds,
    clearList,
    isListSaving,
    isListInvalidated,
    getPagination,
    updateListPagination,
    isLoadingObjects,
    hasListObjectsLoaded
} from './orm_list_actions'

import {
    getObjectsFromState,
    getAllObjects,
    createObject,
    getObject,
    invalidateObjects,
    updateObject,
    getIsSavingObject,
    replaceObjectWithoutSaving
} from './orm_objects_actions'

import * as httpAdapter from './http_adapter'

import { absUrl } from '../lib/http.js'

import { union, get, startsWith, map } from 'lodash'

let STATE;

export function syncORMWithStore(store) {
    STATE = store;
}

export const ORM_LIST_KEY = '@lists'
export const ORM_OBJECT_KEY = '@objects'

export const adapters = {
    httpAdapter
}

export class ItemList {
    clearList() {
        return clearList(this.listKey)
    }

    static adapters = {
        http: 'http'
    }

    getAdapterName() {
        return this.adapterName
    }

    errorMessage(e) {
        
    }

    static itemUrl(url, absolute=false, params) {
        if (!startsWith(url, '/')) {
            url = '/' + url
        }
        if (absolute) {
            return absUrl((new this()).getEntityKey() + url, params)
        } else {
            return (new this()).getEntityKey() + url
        }
    }

    constructor(listKey, adapter) {
        this.listKey = listKey
        this.pagination = {}
        this.fixResponse = this.fixResponse.bind(this)

        this.adapter = httpAdapter
        this.adapterName = 'http'

    }

    fixResponse(json) {
        return json
    }

    deleteObject(objectId, onDone) {
        return this.adapter.deleteObject(this.getEntityKey(), this.listKey, objectId, onDone)
    }

    getNewObjects() {
        return this.getObjects().filter(i => i.isNewInstance)
    }

    createObject(values) {
        return createObject(this.getEntityKey(), this.listKey, values);
    }

    saveObject(instance, onDone) {
        if (instance.isNewInstance) {
            return this.adapter.saveNewObject(this.getEntityKey(), this.listKey, instance, onDone);
        } else {
            return this.adapter.saveObject(this.getEntityKey(), this.listKey, instance, onDone);
        }
    }

    saveNewObject(instance, onDone) {
        return this.adapter.saveNewObject(this.getEntityKey(), this.listKey, instance, onDone);
    }

    patchObject(instance, onDone) {
        return this.adapter.patchObject(this.getEntityKey(), this.listKey, instance, onDone);
    }

    handlePost(postData, onDone) {
        return this.adapter.handlePost(this.getEntityKey(), this.listKey, postData, onDone);
    }

    replaceObjectWithoutSaving(newInstance) {
        return replaceObjectWithoutSaving(this.getEntityKey(), this.listKey, newInstance)
    }

    invalidateObject(objectId) {
        return invalidateObjects([objectId], this.getEntityKey())
    }

    invalidateObjects(objectIds) {
        return invalidateObjects(objectIds, this.getEntityKey())
    }

    getState() {
        return STATE.getState()
    }

    getBaseUrl() {
        return this.getEntityKey() + "/"
    }

    updateObject(instance) {
        return updateObject(this.getEntityKey(), this.listKey, instance);
    }

    fetchListIfNeeded(forceUpdate) {
        return (dispatch, getState) => {
            return dispatch(this.adapter.fetchListIfNeeded(
                this.listKey,
                this.getEntityKey(),
                this.getBaseUrl(),
                this.fixResponse,
                forceUpdate)
            )
        }
    }

    invalidateList() {
        return invalidateList(this.listKey)
    }

    hasListObjectsLoaded() {
        return hasListObjectsLoaded(this.listKey, this.getState())
    }

    isListInvalidated() {
        return isListInvalidated(this.listKey, this.getState())
    }

    updateListFilter(newFilter) {
        return updateListFilter(this.listKey, Object.assign({}, {page: 1}, newFilter))
    }

    clearListFilter() {
        return clearListFilter(this.listKey)
    }

    updateListOrdering(ordering) {
        return updateListOrdering(this.getEntityKey(), this.listKey, ordering)
    }

    ensureObjectsLoaded(itemIds) {
        return this.adapter.ensureObjectsLoaded(this.getEntityKey(), this.listKey, itemIds, this.getBaseUrl(), this.fixResponse)
    }

    ensureObjectLoaded(itemId, on_done) {
        return this.adapter.ensureObjectsLoaded(this.getEntityKey(), this.listKey, [itemId], this.getBaseUrl(), this.fixResponse, on_done)
    }

    getObject(itemId) {
        if (itemId === null || itemId === undefined) {
            return {}
        }
        return getObject(this.getState(), this.getEntityKey(), itemId)
    }

    getObjectsById() {
        return get(this.getState(), `${ORM_OBJECT_KEY}.${this.getEntityKey()}.itemsById`) || {}
    }

    getVisibleObjects() {
        return this.getObjects(undefined)
    }

    getPagination() {
        return getPagination(this.listKey, this.getState())
    }

    updatePaginationNumItemsPerPage(items_per_page) {
        return updateListPagination(this.listKey, {items_per_page:items_per_page})
    }

    getIsSavingObject() {
        return getIsSavingObject(this.getEntityKey(), this.getState())
    }

    getIsUpdatingObject(item_id) {
        return getIsSavingObject(this.getEntityKey() + "/" + item_id, this.getState())
    }
    
    getObjects(itemIds) {
        const state = this.getState()
        if (state) {
            if (itemIds === undefined) {
                itemIds = get(state, `${ORM_LIST_KEY}.${this.listKey}.visibleItemIds`) || []
            }
            return getObjectsFromState(state, this.getEntityKey(), itemIds)
        } else {
            return []
        }
    }

    getAllObjects() {
        const state = this.getState()
        return getAllObjects(state, this.getEntityKey())
    }

    getVisibleItemIds() {
        const state = this.getState()
        if (state) {
            return get(state, `${ORM_LIST_KEY}.${this.listKey}.visibleItemIds`) || []
        } else {
            return []
        }
    }

    getAsOptions(args) {
        const { empty_option_label } = args || {}
        let items = get(args, "items", this.getVisibleObjects())
        items = map(items, function(item) { return {label: item.name, value: item.id}})
        if ( empty_option_label ) {
            items = union([{label: empty_option_label, value: null}], items)
        }
        return items
    }

    getAsOptionsFullValue() {
        const items = this.getVisibleObjects()
        return map(items, function(item) { return {label: item.name, value: item}})
    }

    isLoading() {
        return isListLoading(this.listKey, this.getState()) || 
               isLoadingObjects(this.listKey, this.getState())
    }
    
    isSaving() {
        return isListSaving(this.listKey, this.getState())
    }

    isHandlingPost() {
        return isListHandlingPost(this.listKey, this.getState())
    }

    getFilter() {
        return getFilter(this.listKey, this.getState())
    }

    selectObjectId(id) {
        return this.selectObjectIds([id])
    }
    
    selectObjectIds(ids) {
        return updateListSelection(this.listKey, ids)
    }

    getSelectedObjectIds() {
        return getSelectedIds(this.listKey, this.getState())
    }

    getSelectedObjectId() {
        const ids = this.getSelectedObjectIds()
        if ( ! ids || ids.length === 0 ) {
            return null
        }
        return ids[0]
    }

    getSelectedObject() {
        return this.getObject(this.getSelectedObjectId())
    }

    getVisibleRelatedObjectIdsByField(field) {
        const visible_objects = this.getVisibleObjects()
        let related_object_ids = []
        map(visible_objects, (object) => {
            const related_object_id = get(object, field, null)
            if (related_object_id) {
                related_object_ids.push(related_object_id)
            }
        })
        return related_object_ids
    }
}
